import { SMSProviders } from '../../../api';
import { FormValues, ValidationErrors } from './types';

export const maxFieldLength = 64;
export const maxTwilioTokenLength = 1024;
export const maxPhoneNumberLength = 20;

export const SmsProvidersValidator = (values: FormValues): ValidationErrors => {
  const errors: ValidationErrors = {
    [SMSProviders.amazon]: {},
    [SMSProviders.twilio]: {},
    [SMSProviders.sinch]: {},
    [SMSProviders.telnyx]: {},
    [SMSProviders.smscenter]: {},
    [SMSProviders.alibaba]: {}
  };

  Object.entries(values.selected_providers)
    .filter(([, value]) => value)
    .forEach(([provider]) => {
      if (!values.fields[provider].app_secret) {
        errors[provider].app_secret = 'app.validation.required';
      }

      Object.entries(values.fields[provider]).forEach(([key, field]) => {
        if (typeof field === 'string' && field.length > maxFieldLength) {
          errors[provider][key] = 'app.validation.characters';
        }
      });

      if (
        values.fields[provider].phone_number &&
        values.fields[provider].phone_number!.length > maxPhoneNumberLength
      ) {
        errors[provider].phone_number = 'app.validation.characters';
      }

      if (provider === SMSProviders.telnyx) {
        if (!values.fields[provider].phone_number) {
          errors[provider].phone_number = 'app.validation.required';
        }

        if (values.fields[provider].sender_id && !values.fields[provider].app_id) {
          errors[provider].app_id = 'app.validation.required';
        }

        if (values.fields[provider].app_id && !values.fields[provider].sender_id) {
          errors[provider].sender_id = 'app.validation.required';
        }
      }

      if (provider === SMSProviders.sinch || provider === SMSProviders.twilio) {
        if (!values.fields[provider].phone_number) {
          errors[provider].phone_number = 'app.validation.required';
        }

        if (!values.fields[provider].app_id) {
          errors[provider].app_id = 'app.validation.required';
        }
      }

      if (provider === SMSProviders.amazon) {
        if (!values.fields[provider].aws_region) {
          errors[provider].aws_region = 'app.validation.required';
        }

        if (!values.fields[provider].app_id) {
          errors[provider].app_id = 'app.validation.required';
        }
      }

      if (provider === SMSProviders.twilio && !errors[provider].app_secret) {
        if (
          values.fields[provider].app_secret &&
          values.fields[provider].app_secret.length > maxTwilioTokenLength
        ) {
          errors[provider].app_secret = 'app.validation.characters';
        } else {
          delete errors[provider].app_secret;
        }
      }

      if (provider === SMSProviders.smscenter) {
        if (!values.fields[provider].app_id) {
          errors[provider].app_id = 'app.validation.required';
        }
      }
    });

  return errors;
};
